import { render, staticRenderFns } from "./NotARefund.vue?vue&type=template&id=6e698120&scoped=true&"
import script from "./NotARefund.vue?vue&type=script&lang=js&"
export * from "./NotARefund.vue?vue&type=script&lang=js&"
import style0 from "./NotARefund.vue?vue&type=style&index=0&id=6e698120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e698120",
  null
  
)

export default component.exports